
export const ScoreUtilities = {


	calculateInterviewScore: (ratings: number[], ratingValueMap: { [index: number]: number }) => {
		// The rating and map should have a length
		if (!ratings.length || !Object.keys(ratingValueMap).length) {
			return 0;
		}

		// If three or more ratings are exactly 2 -> disqualify
		const countOfTwos = ratings.filter(r => r === 2).length;
		// If any rating is 1 -> immediate disqualify
		if (ratings.some(r => r === 1) || countOfTwos >= 3) {
			return 0;
		}

		// Sum mapped values for all four slots (missing ratings count as 0)
		const sum = ratings
			.map(r => (r != null ? (ratingValueMap[r] ?? 0) : 0))
			.reduce((s, v) => s + v, 0);
		return sum;
	}

};